var map = {
	"./BodyShape/index.js": [
		8061,
		826
	],
	"./BodyShapeBust/index.js": [
		6452,
		452
	],
	"./BodyShapeHip/index.js": [
		6489,
		489
	],
	"./BodyShapeWaist/index.js": [
		7061,
		61
	],
	"./EnterMeasureManually/index.js": [
		372,
		372
	],
	"./FitPreference/index.js": [
		8684,
		684
	],
	"./FullBodyShapes/index.js": [
		2963,
		963
	],
	"./Gender/index.js": [
		8758,
		758
	],
	"./Result/Measures/index.js": [
		1381,
		381
	],
	"./Result/MeasuresFits/index.js": [
		2817,
		817
	],
	"./Result/TopTwo/index.js": [
		1350,
		350
	],
	"./Result/index.js": [
		5153,
		153
	],
	"./TShirtSize/index.js": [
		8318,
		318
	],
	"./TryOn/index.js": [
		3343,
		719,
		722
	],
	"./sizeChart/index.js": [
		9552,
		552
	],
	"./test/index.js": [
		3483,
		483
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1533;
module.exports = webpackAsyncContext;